/* eslint-disable @typescript-eslint/no-unused-vars */
"use client";

import {
  CookieOptionsWithName,
  createBrowserClient as _createBrowserClient,
} from "@supabase/ssr";
import {
  GenericSchema,
  SupabaseClientOptions,
} from "@supabase/supabase-js/dist/module/lib/types";

import { SupabaseClient } from "@supabase/supabase-js";

/**
 * Create a Supabase client for use in the browser.
 * The function uses environment variables directly and ignores any passed parameters.
 * @param supabaseUrl Deprecated: Supabase URL
 * @param supabaseKey Deprecated: Supabase key
 * @param options Deprecated: Supabase options
 * @param cookieOptions Deprecated: Supabase cookie options
 * @param isSingleton Deprecated: is singleton?
 */
export function createClientComponentClient<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- this type comes from the supabase library itself
  Database = any,
  SchemaName extends string & keyof Database = "public" extends keyof Database
    ? "public"
    : string & keyof Database,
  Schema extends GenericSchema = Database[SchemaName] extends GenericSchema
    ? Database[SchemaName]
    : // eslint-disable-next-line @typescript-eslint/no-explicit-any -- this type comes from the supabase library itself
      any,
>({
  supabaseUrl,
  supabaseKey,
  options,
  cookieOptions,
  isSingleton,
}: {
  supabaseUrl?: string;
  supabaseKey?: string;
  options?: SupabaseClientOptions<SchemaName>;
  cookieOptions?: CookieOptionsWithName;
  isSingleton?: boolean;
} = {}): SupabaseClient<Database, SchemaName, Schema> {
  return _createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!
  );
}
